'use client';

import { BlockHeaderContent } from '@/cms/BlockHeaderContentDC';

import ProductCard from './ProductCard';
import { ProductCardsGroupProps } from './types';
import { PagedCarousel } from '@/components/atoms/PagedCarousel';
import { cn } from '@/lib/utils';

export default function ProductCardsSection(props: ProductCardsGroupProps) {
  const { groupHeader, cards: cardItems, product_cards_groups } = props;
  const groupedCards = product_cards_groups?.data?.flatMap(
    (group) => group.attributes?.productCardsElements
  );
  const allCards = !!groupedCards?.length ? groupedCards : cardItems;

  if (!allCards?.length) {
    return null;
  }

  const fullWidthCards = allCards.filter((card) => !!card.useCases?.length);
  const carouselCards = allCards.filter((card) => !card.useCases?.length);

  return (
    <BlockHeaderContent
      {...groupHeader}
      classNames={{
        header: 'md:mb-12',
        subtitle: 'lg:mt-4',
      }}
    >
      {fullWidthCards.map((card) => (
        <ProductCard key={card.id} className='w-full' {...card} />
      ))}
      <PagedCarousel
        aria-label={`${
          typeof groupHeader?.title === 'string'
            ? groupHeader.title
            : 'Product Cards'
        } carousel`}
        items={carouselCards}
        renderItem={({ item, isGrid }) => (
          <ProductCard
            key={item.id}
            className={cn('min-h-[476px] w-full', isGrid && 'border-gray-300')}
            {...item}
          />
        )}
        itemsPerPage={{ desktop: 4 }}
        itemWidth={carouselCards.length > 1 ? { mobile: '280px' } : undefined}
        showEdgeFade
        peekPreviewSurroundingPages
        classNames={{ viewport: 'py-2', root: 'gap-4' }}
      />
    </BlockHeaderContent>
  );
}
